import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { useSelector } from 'react-redux';
import { Paper, Grid, ToggleButton, ToggleButtonGroup, TextField, FormHelperText } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircleSharp';
import CancelIcon from '@mui/icons-material/CancelSharp';
import { useTranslation } from 'src/i18n';
import { formatDate } from 'src/utils/utils';

export default function CommissioningSignOff ({ data, onChange, readOnly, statusError }) {
  const { t } = useTranslation();
  const user: any = useSelector((state: any) => state.authentication.get('user'));
  const status = data?.get('commissioningStatus') || '';

  const statusOptions = [
    { value: 'pass', label: t('common.pass'), icon: <CheckCircleIcon /> },
    { value: 'pass-with-notes', label: t('common.passWithNotes') },
    { value: 'failed', label: t('common.failed'), icon: <CancelIcon /> },
  ];

  return (
    <Paper style={{ padding: '24px' }}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <p className="sign-off-field"><b>{t('testingReport.signOff.verifiedBy')}</b> {user?.get('first_name')} {user?.get('last_name')}</p>
        </Grid>
        <Grid item xs={12} sm={6}>
          <p className="sign-off-field"><b>{t('testingReport.signOff.date')}</b> {formatDate(new Date())}</p>
        </Grid>

        <Grid item xs={12}>
          <p className="sign-off-label">
            {t('common.commissioningStatus')} *
          </p>
          <ToggleButtonGroup
            value={status}
            exclusive
            onChange={(_, val) => { if (val) onChange(['signOff', 'commissioningStatus'], val); }}
            disabled={readOnly}
            style={{ width: '100%' }}
          >
            {statusOptions.map(opt => (
              <ToggleButton
                key={opt.value}
                value={opt.value}
                className={`commissioning-status-${opt.value}`}
                style={{ flex: 1, padding: '16px', fontSize: '1rem', fontWeight: 600 }}
              >
                {opt.icon && <span style={{ marginRight: 8, display: 'flex', alignItems: 'center' }}>{opt.icon}</span>}
                {opt.label}
              </ToggleButton>
            ))}
          </ToggleButtonGroup>
          {statusError && <FormHelperText error>{t('common.commissioningStatusRequired')}</FormHelperText>}
        </Grid>

        <Grid item xs={12}>
          <TextField
            multiline
            rows={6}
            fullWidth
            value={data?.get('recommendations') || ''}
            disabled={readOnly}
            label={t('testingReport.signOff.recommendations')}
            onChange={(e) => onChange(['signOff', 'recommendations'], e.target.value)}
          />
        </Grid>
      </Grid>
    </Paper>
  );
}

CommissioningSignOff.propTypes = {
  data: ImmutablePropTypes.map,
  onChange: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  statusError: PropTypes.bool,
};

CommissioningSignOff.defaultProps = {
  readOnly: false,
  statusError: false,
};
